import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import Rating from "semantic-ui-react/dist/es/modules/Rating/Rating.js";
import { Paragraph } from "../../typography/Paragraph";
import { InputController } from "../InputController";
import { getRatingData } from "./utils/getRatingData";
import { MAX_RATING, ON_RATE_HANDLER } from "./constants";
export var Component = function Component(_ref) {
  var error = _ref.error,
      iconSize = _ref.iconSize,
      label = _ref.label,
      name = _ref.name,
      onChange = _ref.onChange,
      value = _ref.value;
  return React.createElement(Fragment, null, !!label && React.createElement(Paragraph, null, label), React.createElement(InputController, {
    adaptOnChangeEvent: getRatingData,
    error: error,
    inputOnChangeFunctionName: ON_RATE_HANDLER,
    isValid: false,
    name: name,
    onChange: onChange,
    value: value
  }, React.createElement(Rating, {
    maxRating: MAX_RATING,
    rating: value,
    size: iconSize
  })));
};
Component.displayName = 'RatingInput';
Component.defaultProps = {
  error: false,
  iconSize: 'small',
  label: '',
  name: '',
  onChange: Function.prototype,
  value: undefined
};
Component.propTypes = process.env.NODE_ENV !== "production" ? {
  error: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  iconSize: PropTypes.oneOf(['tiny', 'small']),
  label: PropTypes.string,
  name: PropTypes.string,
  onChange: PropTypes.func,
  value: PropTypes.number
} : {};